import { MoreVert, PersonOff, RequestPage, Warning } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  areAllROAssigned,
  areAllTechniciansAssigned,
  isReconditioning,
} from '../../helpers/reconditioning';

const TechnicianIcon = ({ order, enableTechnicianIcon = true }) => {
  const { t } = useTranslation('workOrdersTable');

  if (!enableTechnicianIcon) return null;
  if (areAllTechniciansAssigned(order)) return null;

  return (
    <Tooltip
      title={
        <>
          <Typography sx={{ fontSize: '10px' }}>
            {t('vehicleTable.tooltip.title')}
          </Typography>
          <Typography sx={{ fontSize: '10px' }}>
            {t('vehicleTable.tooltip.technician')}
          </Typography>
        </>
      }
      arrow
    >
      <PersonOff color="warning" gap={1} />
    </Tooltip>
  );
};

const RequiredApprovalIcon = ({ order }) => {
  const { t } = useTranslation('workOrdersTable');

  if (!order.requiresApproval) return null;

  return (
    <Tooltip
      title={
        <>
          <Typography sx={{ fontSize: '10px' }}>
            {t('vehicleTable.tooltip.title')}
          </Typography>
          <Typography sx={{ fontSize: '10px' }}>
            {t('vehicleTable.tooltip.warning')}
          </Typography>
        </>
      }
      arrow
    >
      <Warning color="warning" gap={1} />
    </Tooltip>
  );
};

const ReconditioningOrderIcon = ({ order }) => {
  const { t } = useTranslation('workOrdersTable');

  if (areAllROAssigned(order)) return null;

  return (
    <Tooltip title={t('vehicleTable.tooltip.ROMissing')} arrow>
      <RequestPage color="warning" gap={1} />
    </Tooltip>
  );
};

export default function ActionsColumn({
  order,
  onOpen,
  enableTechnicianIcon = true,
}) {
  if (!isReconditioning(order)) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      gap={1}
    >
      <ReconditioningOrderIcon order={order} />
      <TechnicianIcon
        order={order}
        enableTechnicianIcon={enableTechnicianIcon}
      />
      <RequiredApprovalIcon order={order} />
      <IconButton
        sx={{ color: 'rgba(0, 0, 0, 0.54)', p: 0 }}
        onClick={onOpen}
        id={order?.orderId}
        size="small"
      >
        <MoreVert />
      </IconButton>
    </Stack>
  );
}
